import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Accompaniment } from '../../models/accompaniment.interface'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { environment } from '../../../environments/environment'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'
import { RequestService } from '../request/request.service'
import { QueryGet } from '../../shared/query-types'
import { Pagination } from '../../models/pagination.interface'

@Injectable({
    providedIn: 'root',
})
export class AccompanimentService {
    private apiAccompaniment = environment.service_1 + 'create-accompaniment'
    private apiUpdateAccompaniment =
        environment.service_1 + 'update-accompaniment'
    private apiUrl = environment.service_1 + 'accompaniments/'

    private accompanimentsSubject = new BehaviorSubject<Accompaniment[]>([])
    public accompaniments$ = this.accompanimentsSubject.asObservable()

    private selectedAccompanimentSubject =
        new BehaviorSubject<Accompaniment | null>(null)

    public selectedAccompanimentSubject$ =
        this.selectedAccompanimentSubject.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    constructor(
        private http: HttpClient,
        private requestService: RequestService
    ) {}

    setSelectedAccompaniment(accompaniment: Accompaniment): void {
        this.selectedAccompanimentSubject.next(accompaniment)
    }

    setAccompaniments(accompaniment: Accompaniment[]): void {
        this.accompanimentsSubject.next(accompaniment)
    }

    removeSelectedAccompaniment(): void {
        this.selectedAccompanimentSubject.next(null)
    }

    getAccompanimentId(id: number | string) {
        return this.http.get<Accompaniment>(this.apiAccompaniment + `${id}/`)
    }

    allAccompaniments(
        queryParams: QueryGet
    ): Observable<Pagination<Accompaniment[]>> {
        return this.requestService.get<Accompaniment[]>(
            this.apiUrl,
            queryParams
        )
    }

    createAccompaniment(
        payload: Accompaniment | FormData
    ): Observable<Accompaniment> {
        return this.http
            .post<Accompaniment>(this.apiAccompaniment, payload)
            .pipe(
                tap({
                    error: (err: HttpErrorResponse) => {
                        this.asyncErrorValidation.next(err.error)
                    },
                })
            )
    }

    updateAccompaniment(
        id: number,
        payload: Accompaniment | FormData
    ): Observable<Accompaniment> {
        return this.http
            .put<Accompaniment>(`${this.apiUpdateAccompaniment}/${id}`, payload)
            .pipe(
                tap({
                    error: (err: HttpErrorResponse) =>
                        this.asyncErrorValidation.next(err.error),
                })
            )
    }

    deleteAccompaniment(id: number): Observable<any> {
        return this.http.delete(`${this.apiUrl}${id}/`)
    }
}
